<template>
  <div class="layout-container">
    <div class="resource-filters">
      <template v-if="!isLessThanDesktop">
        <p>Filter by</p>

        <filter-input
          name="types"
          :disabled="typesFilterArray.length === 0"
          aria-label="Filter by article types"
          @update:value="handleFiltersChange"
          injectionName="articletypefilter"
        >
          <template #options="{ selectionHandler, selectionArray }">
            <li
              v-for="filtertype in typesFilterArray"
              :key="filtertype.name + filtertype.id + 'option'"
              class="select__option"
            >
              <input
                :id="filtertype.name + filtertype.id + 'option'"
                :name="filtertype.name + filtertype.id + 'option'"
                type="checkbox"
                :value="filtertype.name"
                :checked="selectionArray?.indexOf(filtertype.name) !== -1"
                @input="selectionHandler"
              />
              <label :for="filtertype.name + filtertype.id + 'option'">{{
                filtertype.name
              }}</label>
            </li>
          </template>
        </filter-input>

        <filter-input
          name="category"
          :disabled="categoriesFilterArray.length === 0"
          aria-label="Filter by article categories"
          @update:value="handleFiltersChange"
          injectionName="articlecategoryfilter"
        >
          <template #options="{ selectionHandler, selectionArray }">
            <li
              v-for="filtertype in categoriesFilterArray"
              :key="filtertype.name + filtertype.id + 'option'"
              class="select__option"
            >
              <input
                :id="filtertype.name + filtertype.id + 'option'"
                :name="filtertype.name + filtertype.id + 'option'"
                type="checkbox"
                :value="filtertype.name"
                :checked="selectionArray?.indexOf(filtertype.name) !== -1"
                @input="selectionHandler"
              />
              <label :for="filtertype.name + filtertype.id + 'option'">{{
                filtertype.name
              }}</label>
            </li>
          </template>
        </filter-input>

        <filter-input
          name="year"
          :disabled="yearsFilterArray.length === 0"
          injectionName="articleyearfilter"
          aria-label="Filter article years"
          @update:value="handleFiltersChange"
        >
          <template #options="{ selectionHandler, selectionArray }">
            <li
              v-for="filtertype in yearsFilterArray"
              class="select__option"
              :key="filtertype.name + filtertype.id + 'option'"
            >
              <input
                :id="filtertype + 'option'"
                :name="filtertype + 'option'"
                type="checkbox"
                :value="filtertype.toString()"
                :checked="selectionArray?.indexOf(filtertype.toString()) !== -1"
                @input="selectionHandler"
              />
              <label :for="filtertype + 'option'">{{ filtertype }}</label>
            </li>
          </template>
        </filter-input>
      </template>

      <button
        v-if="isLessThanDesktop"
        class="button button--outlined mobile-filter-button"
        @click="openSheetHandler"
      >
        <span
          ><i class="icon icon-filter-2 icon-color--red icon--sm"></i>
          Filter</span
        >

        <span
          v-if="
            filtersSelected['types'].length > 0 ||
            filtersSelected['category'].length > 0 ||
            filtersSelected['year'].length > 0
          "
          >{{ filteredContentLength }} result(s)</span
        >
      </button>
    </div>

    <vue-bottom-sheet
      ref="myBottomSheet"
      max-width="1200px"
      :full-screen="true"
    >
      <div class="mobile-filters">
        <div class="mobile-filters__header">
          <div></div>
          <div class="mobile-filters__header-heading">
            <span class="heading-h5">Filters</span>
          </div>
          <div class="mobile-filters__header-close">
            <button
              role="button"
              aria-label="Dismiss modal"
              class="button--text button--icon base-model__header-close"
              :onClick="
                () => {
                  closeSheetHandler();
                }
              "
            >
              <i class="icon icon-close icon--xs" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div class="mobile-filters__body">
          <filter-input
            name="types"
            aria-label="Filter by article types"
            injectionName="articletypefilter"
            :disabled="typesFilterArray.length === 0"
            @update:value="handleMobileFilterChange"
          >
            <template #options="{ selectionHandler, selectionArray }">
              <li
                v-for="filtertype in typesFilterArray"
                class="select__option"
                :key="filtertype.name + filtertype.id + 'option'"
              >
                <input
                  :id="filtertype.name + filtertype.id + 'option'"
                  :name="filtertype.name + filtertype.id + 'option'"
                  type="checkbox"
                  :value="filtertype.name"
                  :checked="selectionArray?.indexOf(filtertype.name) !== -1"
                  @input="selectionHandler"
                />
                <label :for="filtertype.name + filtertype.id + 'option'">{{
                  filtertype.name
                }}</label>
              </li>
            </template>
          </filter-input>

          <filter-input
            name="category"
            aria-label="Filter by article categories"
            :disabled="categoriesFilterArray.length === 0"
            @update:value="handleMobileFilterChange"
            injectionName="articlecategoryfilter"
          >
            <template #options="{ selectionHandler, selectionArray }">
              <li
                v-for="filtertype in categoriesFilterArray"
                :key="filtertype.name + filtertype.id + 'option'"
                class="select__option"
              >
                <input
                  :id="filtertype.name + filtertype.id + 'option'"
                  :name="filtertype.name + filtertype.id + 'option'"
                  type="checkbox"
                  :value="filtertype.name"
                  :checked="selectionArray?.indexOf(filtertype.name) !== -1"
                  @input="selectionHandler"
                />
                <label :for="filtertype.name + filtertype.id + 'option'">{{
                  filtertype.name
                }}</label>
              </li>
            </template>
          </filter-input>

          <filter-input
            name="year"
            aria-label="Filter article years"
            :disabled="yearsFilterArray.length === 0"
            @update:value="handleMobileFilterChange"
            injectionName="articleyearfilter"
          >
            <template #options="{ selectionHandler, selectionArray }">
              <li
                v-for="filtertype in yearsFilterArray"
                class="select__option"
                :key="filtertype.name + filtertype.id + 'option'"
              >
                <input
                  :id="filtertype + 'option'"
                  :name="filtertype + 'option'"
                  type="checkbox"
                  :value="filtertype.toString()"
                  :checked="
                    selectionArray?.indexOf(filtertype.toString()) !== -1
                  "
                  @input="selectionHandler"
                />
                <label :for="filtertype + 'option'">{{ filtertype }}</label>
              </li>
            </template>
          </filter-input>
        </div>
        <div class="mobile-filters__footer" v-if="isLessThanDesktop">
          <button
            role="button"
            aria-label="Dismiss modal"
            class="button button--text button--sm"
            :onClick="
              () => {
                closeSheetHandler();
              }
            "
          >
            Reset
          </button>
          <button
            role="button"
            aria-label="Dismiss modal"
            class="button button--sm"
            :disabled="!stateChanged"
            :onClick="
              () => {
                mobileUpdateFiltersHandler();
              }
            "
          >
            Update
          </button>
        </div>
      </div>
    </vue-bottom-sheet>

    <div
      v-if="
        filtersSelected['types'].length > 0 ||
        filtersSelected['category'].length > 0 ||
        filtersSelected['year'].length > 0
      "
      class="
        resource-filters__active-filters
        article-filter__active-filters-container
      "
    >
      <div class="article-filter__active-filters">
        <div
          v-for="(filter, index) in filtersSelected['types']"
          :key="index"
          class="selected-option"
        >
          {{ filter }}
          <button
            class="remove-button"
            @click="
              () => {
                handleRemoveFilter('types', filter);
              }
            "
          >
            <i
              class="icon icon-close icon--xxs icon-color--red"
              aria-hidden="true"
            ></i>
          </button>
        </div>
        <div
          v-for="(filter, index) in filtersSelected['category']"
          :key="index"
          class="selected-option"
        >
          {{ filter }}
          <button
            class="remove-button"
            @click="
              () => {
                handleRemoveFilter('category', filter);
              }
            "
          >
            <i
              class="icon icon-close icon--xxs icon-color--red"
              aria-hidden="true"
            ></i>
          </button>
        </div>
        <div
          v-for="(filter, index) in filtersSelected['year']"
          :key="index"
          class="selected-option"
        >
          {{ filter }}
          <button
            class="remove-button"
            @click="
              () => {
                handleRemoveFilter('year', filter);
              }
            "
          >
            <i
              class="icon icon-close icon--xxs icon-color--red"
              aria-hidden="true"
            ></i>
          </button>
        </div>
        <button
          v-if="
            filtersSelected['types'].length > 0 ||
            filtersSelected['category'].length > 0 ||
            filtersSelected['year'].length > 0
          "
          class="button button--text"
          @click="resetFilters"
        >
          Reset filters
        </button>
      </div>
    </div>
  </div>

  <div v-if="hasSelection" class="article-filter__results">
    <div class="bg-beige-fade-with-arch">
      <div class="spacer-small"></div>
      <div
        class="layout-artilclelandindscontent layout-artilclescontent__cards"
      >
        <div class="filtered-resource-block">
          <div class="layout-container">
            <div class="filtered-resource-block__content">
              <div
                v-for="article in filteredContent"
                :key="article.link"
                class="card-text__below"
              >
                <div class="card">
                  <div class="card-image">
                    <a :href="article.link">
                      <picture>
                        <img
                          :src="
                            isStorybook
                              ? '/images/srb-placeholder-1.png'
                              : article.imageURL
                          "
                          alt="Image alternative text"
                          loading="lazy"
                          height="220"
                        />
                      </picture>
                    </a>
                  </div>
                  <div class="card-body">
                    <div class="card-subtitle">
                      <p class="card-subtitle__date fs-12">
                        {{ article.date }}
                      </p>
                      <p
                        v-for="c in article.categories"
                        :key="c"
                        class="
                          link link--pill link--pill-sm link--pill-alt
                          bg-KQ-Gold-30
                        "
                      >
                        {{ c }}
                      </p>
                    </div>
                    <div class="card-title">
                      <a :href="article.link" class="link"
                        ><h4>{{ article.title }}</h4></a
                      >
                    </div>
                    <div class="card-text">
                      <p class="fs-14">{{ article.description }}</p>
                    </div>
                    <div class="card-links">
                      <social-share :article-link="article.link">
                        <button
                          role="button"
                          aria-label="Optional description of what happens when the link is clicked"
                          class="
                            button button--text button--iconleft
                            paragraph-note
                            text--bold
                          "
                        >
                          <i
                            class="
                              icon icon-social-share
                              icon-color--red
                              icon--xxs
                            "
                            aria-hidden="true"
                          />
                          Share
                        </button>
                      </social-share>
                      <span>|</span
                      ><a
                        v-if="article.downloadLink"
                        :href="article.downloadLink"
                        class="text--bold link link--iconleft fs-14"
                      >
                        <i
                          class="icon icon-download icon-color--red"
                          aria-hidden="true"
                          download
                        />
                        Download PDF
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button
              v-if="showLoadMoreButton"
              role="button"
              aria-label="Show more acticles"
              class="button button--outlined"
              @click="loadMoreArticles"
            >
              Show more
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <slot
    v-if="!hasSelection"
    name="page"
    :handleFiltersChange="handleFiltersChange"
  ></slot>

  <div v-if="hasSelection && moreToShow" class="layout-container">
    <button
      role="button"
      aria-label="Load more"
      class="button button--outlined"
      :disabled="loading"
      @click="loadMore"
    >
      Load more
    </button>
    <div class="spacer-default"></div>
  </div>
</template>

<script setup>
import {
  ref,
  onMounted,
  watch,
  provide,
  onBeforeUnmount,
  onBeforeMount,
} from 'vue';
import { useQuery } from '@tanstack/vue-query';
import optiClient from '../../services/api';
import FilterInput from '../FilterInput/FilterInput.vue';
import SocialShare from '../SocialShare/SocialShare.vue';
import { useIsBreakpointSize } from '../../hooks/useIsMobile';
import '@webzlodimir/vue-bottom-sheet/dist/style.css';
import { VueBottomSheet } from '@webzlodimir/vue-bottom-sheet';

const isLessThanDesktop = useIsBreakpointSize(991);
const typesFilterArray = ref([]);
const categoriesFilterArray = ref([]);
const yearsFilterArray = ref([]);
const randomId = Math.random().toString(36).substring(2, 12);

const filteredContentLength = ref();
const filteredContent = ref([]);
const hasSelection = ref(false);
const myBottomSheet = ref(null);
const stateChanged = ref(false);
const isStorybook = ref(false);
const page = ref(1);
const moreToShow = ref(false);
const loading = ref(false);

const props = defineProps({
  pageSize: {
    type: Number,
    default: 5,
  },
  pageId: {
    type: String
  }
});
const filtersSelected = ref({
  types: [],
  category: [],
  year: [],
});
const tempState = ref({
  types: [],
  category: [],
  year: [],
});

const typesQuery = useQuery({
  queryKey: ['articletypes', randomId],
  queryFn: async () => {
    try {
      const res = await optiClient.search.getApiV1FindArticlesAvailableTypes(props.pageId);
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  refetchOnWindowFocus: false,
});

watch(typesQuery.data, () => {
  if (typesQuery.status?.value === 'success') {
    if (typesQuery?.data?.value?.data) {
      typesFilterArray.value = typesQuery?.data?.value?.data
        ? [...typesQuery?.data?.value?.data]
        : [];
    }
    if (
      typesFilterArray.value.length > 0 &&
      categoriesFilterArray.value.length > 0 &&
      yearsFilterArray.value.length > 0
    ) {
      loadURL();
    }
  }
});

const categoriesQuery = useQuery({
  queryKey: ['articlecategories', randomId],
  queryFn: async () => {
    try {
      const res =
        await optiClient.search.getApiV1FindArticlesAvailableCategories(props.pageId);
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  refetchOnWindowFocus: false,
});

watch(categoriesQuery.data, () => {
  if (categoriesQuery.status?.value === 'success') {
    if (categoriesQuery?.data?.value?.data) {
      categoriesFilterArray.value = categoriesQuery?.data?.value?.data
        ? [...categoriesQuery?.data?.value?.data]
        : [];
    }
    if (
      typesFilterArray.value.length > 0 &&
      categoriesFilterArray.value.length > 0 &&
      yearsFilterArray.value.length > 0
    ) {
      loadURL();
    }
  }
});

const yearsQuery = useQuery({
  queryKey: ['articleyears', randomId],
  queryFn: async () => {
    try {
      const res = await optiClient.search.getApiV1FindArticlesAvailableYears(props.pageId);
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  refetchOnWindowFocus: false,
});

watch(yearsQuery.data, () => {
  if (yearsQuery.status?.value === 'success') {
    if (yearsQuery?.data?.value?.data) {
      yearsFilterArray.value = yearsQuery?.data?.value?.data
        ? [...yearsQuery?.data?.value?.data]
        : [];
    }
    if (
      typesFilterArray.value.length > 0 &&
      categoriesFilterArray.value.length > 0 &&
      yearsFilterArray.value.length > 0
    ) {
      loadURL();
    }
  }
});

const getQueriesHandler = () => {
  const query = {};

  const getFilterIds = (filterArray, selectedValues) => {
    const idArray = [];
    for (let i = 0; i < selectedValues.length; i++) {
      const index = filterArray?.value.findIndex(
        (obj) => obj.name === selectedValues[i],
      );
      if (index !== -1) {
        const id = filterArray?.value[index].id;
        if (id) {
          idArray.push(id);
        }
      }
    }
    return idArray.join(',');
  };

  if (filtersSelected?.value?.types?.length > 0) {
    query.types = getFilterIds(typesFilterArray, filtersSelected?.value?.types);
  }

  if (filtersSelected?.value?.category?.length > 0) {
    query.categories = getFilterIds(
      categoriesFilterArray,
      filtersSelected?.value?.category,
    );
  }

  if (filtersSelected?.value?.year.length > 0) {
    query.years = filtersSelected?.value?.year.join(',');
  }

  return query;
};

const fetchArticles = useQuery({
  queryKey: ['fetcharticles', randomId],
  queryFn: async () => {
    const query = getQueriesHandler();
    loading.value = true;
    try {
      const res =
        await optiClient.search.getApiV1FindArticlesSearchAndFiltering(
          '',
          query.types,
          query.categories,
          query.years,
          page.value,
          props.pageSize,
          props.pageId,
        );
      return res;
    } catch (error) {
      loading.value = false;
      console.log(error);
      throw error;
    }
  },
  refetchOnWindowFocus: false,
  enabled: false,
  fetchPolicy: 'no-cache',
});

watch(fetchArticles.data, () => {
  loading.value = false;
  if (fetchArticles.status?.value === 'success') {
    if (page.value !== 1) {
      if (fetchArticles?.data?.value?.data?.results?.length > 0) {
        const combined = [
          ...filteredContent.value,
          ...fetchArticles?.data?.value?.data?.results,
        ];
        filteredContent.value = [...combined];
      }
    } else {
      if (fetchArticles?.data?.value?.data?.results.length > 0) {
        filteredContent.value = fetchArticles?.data?.value?.data?.results
          ? [...fetchArticles?.data?.value?.data?.results]
          : [];
      } else {
        filteredContent.value = [];
      }
      filteredContentLength.value = filteredContent.value.length;
    }

    if (typeof fetchArticles?.data?.value?.data?.showMore === 'boolean') {
      moreToShow.value = fetchArticles?.data?.value?.data?.showMore;
    }
  }
});

const loadMore = () => {
  page.value = page.value + 1;
  fetchArticles.refetch(true);
};

const handleMobileFilterChange = ({ name, value }) => {
  stateChanged.value = true;
  page.value = 1;
  const temp = { ...filtersSelected.value };
  if (value[0] === 'all') {
    temp[name] = [];
  } else {
    temp[name] = [...value];
  }
  tempState.value = { ...temp };
};

const mobileUpdateFiltersHandler = () => {
  filtersSelected.value = { ...tempState.value };
  writeURLParamHandler('types', [...tempState.value?.types]);
  writeURLParamHandler('category', [...tempState.value?.category]);
  writeURLParamHandler('year', [...tempState.value?.year]);

  hasSelection.value = true;
  fetchArticles.refetch(true);
  closeSheetHandler();
};

const handleFiltersChange = ({ name, value }) => {
  page.value = 1;
  const temp = { ...filtersSelected.value };
  if (value[0] === 'all') {
    temp[name] = [];
    writeURLParamHandler(name, '');
  } else {
    temp[name] = [...value];
    writeURLParamHandler(name, [...value]);
  }

  if (temp.types.length + temp.category.length + temp.year.length === 0) {
    filtersSelected.value = { ...temp };
    hasSelection.value = false;
    return;
  }

  filtersSelected.value = { ...temp };
  hasSelection.value = true;
  fetchArticles.refetch(true);
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

const handleRemoveFilter = (key, value) => {
  const temp = { ...filtersSelected.value };
  const index = temp[key].indexOf(value);

  if (index !== -1) {
    temp[key].splice(index, 1);
    writeURLParamHandler(key, [...temp[key]]);
  }

  filtersSelected.value = { ...temp };

  if (
    [
      ...filtersSelected.value.types,
      ...filtersSelected.value.category,
      ...filtersSelected.value.year,
    ].length === 0
  ) {
    hasSelection.value = false;
  }

  fetchArticles.refetch(true);
};

const resetFilters = () => {
  filtersSelected.value = {
    types: [],
    category: [],
    year: [],
  };
  removeURLParamHandler('types');
  removeURLParamHandler('category');
  removeURLParamHandler('year');
  hasSelection.value = false;
};

const readURLParamHandler = (paramName) => {
  const urlParams = new URLSearchParams(window.location.search);
  const paramValue = urlParams.get(paramName);
  return paramValue;
};

const writeURLParamHandler = (paramName, paramValue) => {
  const url = new URL(window.location);
  url.searchParams.set(paramName, paramValue);
  window.history.pushState({}, '', url);
};

const removeURLParamHandler = (paramName) => {
  const url = new URL(window.location);
  url.searchParams.delete(paramName);
  window.history.pushState({}, '', url);
};

const loadURL = () => {
  const temp = {};
  let hasFilter = false;
  // Types filter check
  const urlTypes = readURLParamHandler('types')?.split(',').filter(Boolean);

  if (urlTypes && urlTypes.length > 0) {
    temp['types'] = urlTypes;
    hasFilter = true;
  }

  // Category filter check
  const urlCategories = readURLParamHandler('category')
    ?.split(',')
    .filter(Boolean);

  if (urlCategories && urlCategories.length > 0) {
    temp['category'] = urlCategories;
    hasFilter = true;
  }

  // Category filter check
  const urlYear = readURLParamHandler('year')?.split(',').filter(Boolean);

  if (urlYear && urlYear.length > 0) {
    temp['year'] = urlYear;
    hasFilter = true;
  }

  if (hasFilter) {
    filtersSelected.value = { ...filtersSelected.value, ...temp };
    hasSelection.value = true;
    fetchArticles.refetch(true);
  }
};

const openSheetHandler = () => {
  myBottomSheet.value.open();
  // because of how the bottom sheet destorys the component this needs to be pushed again
  filtersSelected.value = { ...filtersSelected.value };
};

const closeSheetHandler = () => {
  stateChanged.value = false;
  myBottomSheet.value.close();
};

provide('articletypefilter', filtersSelected);
provide('articlecategoryfilter', filtersSelected);
provide('articleyearfilter', filtersSelected);

onMounted(() => {
  const articleResults = document.querySelector('.article-filter__results');
  const articleResultsMobile = document.querySelector(
    '.article-filter__results-mobile',
  );
  const articleCount = document.querySelector('.article-count');
  const articleCountMobile = document.querySelector('.article-count-mobile');
  const activeFiltersContainer = document.querySelector(
    '.article-filter__active-filters-container',
  );
  const activeFiltersContainerMobile = document.querySelector(
    '.article-filter__active-filters-container-mobile',
  );

  if (articleResults && articleResultsMobile) {
    articleResultsMobile.appendChild(articleResults);
  }

  if (articleCount && articleCountMobile) {
    articleCountMobile.appendChild(articleCount);
  }

  if (activeFiltersContainer && activeFiltersContainerMobile) {
    activeFiltersContainerMobile.appendChild(activeFiltersContainer);
  }
});

onBeforeMount(() => {
  isStorybook.value = window.IS_STORYBOOK ? true : false;
});

onMounted(() => {
  window.addEventListener('resize', closeSheetHandler);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', closeSheetHandler);
});
</script>
